export default "__VITE_ASSET__236ed436__"